module.exports = __webpack_public_path__ + "static/media/menu.3ba1a87d.jpg";